import { useState } from 'react'
import EmptyState from './EmptyState.jsx'

export default function StoreList({ stores, loading, onCreate, onDelete, onSelect }) {
  const [showModal, setShowModal] = useState(false)
  const [newName, setNewName] = useState('')
  const [newWidth, setNewWidth] = useState(20)
  const [newHeight, setNewHeight] = useState(30)
  const [creating, setCreating] = useState(false)

  async function handleCreate(e) {
    e.preventDefault()
    if (!newName.trim()) return
    setCreating(true)
    const store = await onCreate(newName.trim(), Number(newWidth), Number(newHeight))
    setCreating(false)
    if (store) {
      setShowModal(false)
      setNewName('')
      setNewWidth(20)
      setNewHeight(30)
      onSelect(store.id)
    }
  }

  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner" />
        <span className="loading-state__text">Winkels laden…</span>
      </div>
    )
  }

  return (
    <div className="store-list">
      <div className="store-list__header">
        <h2 className="store-list__title">Jouw winkels</h2>
        <p className="store-list__subtitle">
          Teken de indeling van je supermarkt en navigeer efficiënt met je boodschappenlijst.
        </p>
      </div>

      <div className="store-list__grid">
        {/* Create new store card */}
        <div
          className="store-card store-card--create"
          onClick={() => setShowModal(true)}
        >
          <div className="store-card__icon">➕</div>
          <span className="store-card__name">Nieuwe winkel</span>
          <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)' }}>
            Maak een plattegrond
          </span>
        </div>

        {/* Existing stores */}
        {stores.map(store => (
          <div
            key={store.id}
            className="store-card"
            onClick={() => onSelect(store.id)}
          >
            <div className="store-card__icon">🏪</div>
            <span className="store-card__name">{store.name}</span>
            <div className="store-card__meta">
              <span className="store-card__meta-item">
                📐 {store.grid_width}×{store.grid_height}
              </span>
              <span className="store-card__meta-item">
                📅 {new Date(store.updated_at).toLocaleDateString('nl-NL')}
              </span>
            </div>
            <div className="store-card__actions">
              <button
                className="btn btn--ghost"
                onClick={(e) => { e.stopPropagation(); onSelect(store.id, 'list') }}
              >
                📝 Boodschappen
              </button>
              <button
                className="btn btn--danger btn--ghost"
                onClick={(e) => {
                  e.stopPropagation()
                  if (confirm('Weet je zeker dat je deze winkel wilt verwijderen?')) {
                    onDelete(store.id)
                  }
                }}
              >
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>

      {stores.length === 0 && (
        <EmptyState
          icon="🗺️"
          title="Nog geen winkels"
          description="Maak je eerste winkelplattegrond aan om te beginnen met slim boodschappen doen."
        />
      )}

      {/* Create modal */}
      {showModal && (
        <div className="create-modal" onClick={() => setShowModal(false)}>
          <form
            className="create-modal__content"
            onClick={e => e.stopPropagation()}
            onSubmit={handleCreate}
          >
            <h3 className="create-modal__title">Nieuwe winkel aanmaken</h3>

            <div className="create-modal__field">
              <label className="create-modal__label" htmlFor="store-name">Winkelnaam</label>
              <input
                id="store-name"
                className="create-modal__input"
                type="text"
                placeholder="bijv. Albert Heijn Centrum"
                value={newName}
                onChange={e => setNewName(e.target.value)}
                autoFocus
              />
            </div>

            <div className="create-modal__row">
              <div className="create-modal__field">
                <label className="create-modal__label" htmlFor="grid-width">Breedte (cellen)</label>
                <input
                  id="grid-width"
                  className="create-modal__input"
                  type="number"
                  min="5"
                  max="50"
                  value={newWidth}
                  onChange={e => setNewWidth(e.target.value)}
                />
              </div>
              <div className="create-modal__field">
                <label className="create-modal__label" htmlFor="grid-height">Hoogte (cellen)</label>
                <input
                  id="grid-height"
                  className="create-modal__input"
                  type="number"
                  min="5"
                  max="50"
                  value={newHeight}
                  onChange={e => setNewHeight(e.target.value)}
                />
              </div>
            </div>

            <div className="create-modal__actions">
              <button
                type="button"
                className="btn"
                onClick={() => setShowModal(false)}
              >
                Annuleren
              </button>
              <button
                type="submit"
                className="btn btn--primary"
                disabled={!newName.trim() || creating}
              >
                {creating ? 'Aanmaken…' : 'Aanmaken'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}
